import React from 'react';
import loaderGif from "../Assests/loader.gif";
import { Box } from '@mui/material';

const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] bg-gray-50">
      <div className="relative">
        {/* Outer circle */}
        <div className="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin">
          {/* Inner circle with gradient effect */}
          <div className="absolute top-0 left-0 w-16 h-16 border-4 border-blue-500 rounded-full animate-spin border-t-transparent"></div>
        </div>
      </div>
      {/* <p className="mt-4 text-gray-600 font-medium">LOADING...</p> */}
      <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="rgba(255, 255, 255, 0.8)"
          zIndex={1}
        >
          <img src={loaderGif} alt="Loading..." width={50} height={50} />
        </Box>
    </div>
  );
};

export default LoadingSpinner;